import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    getBillFailure,
    getBillSuccess,
    billCustomizeFailure,
    billCustomizeSuccess,
    orderHistorySuccess,
    orderHistoryFailure,
    userPlansSuccess,
    userPlansFailure,
    billForecastSuccess,
    billForecastFailure,
    eligiblePayLaterSuccess,
    eligiblePayLaterFailure,
    billPaySuccess,
    billPayFailure,
    emailBillSuccess,
    emailBillFailure,
    promisePaySuccess,
    promisePayFailure,
    getAdvanceSuccess,
    getAdvanceFailure,
    payAdvanceSuccess,
    payAdvanceFailure,
    dataUsageSuccess,
    dataUsageFailure,
    configSuccess,
    configFailure,
    referalDetailFailure,
    referalDetailSuccess,
    toggleIRILDDRSuccess,
    toggleIRILDDRFailure,
    getStatusIRILDDRSuccess,
    getStatusIRILDDRFailure,
    getUsageIRSuccess,
    getUsageIRFailure,
    getUsageDRSuccess,
    getUsageDRFailure,
    getUsageILDSuccess,
    getUsageILDFailure,
} from './actions';
import * as types from './actionTypes';
import apiJunction from '../../utils/api';
import { domainName, domainMap, version } from '../../config';
import ApiEndPoints from '../../utils/ApiEndPoints';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

// get city.state by zipcode
function* getBill(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? action.payload.startDate && action.payload.endDate
                        ? `${ApiEndPoints?.getBill}/${action.payload.customerId}?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}`
                        : `${ApiEndPoints?.getBill}/${action.payload.customerId}`
                    : `${ApiEndPoints?.getBill}/${action.payload.customerId}`,
        });
        yield put(
            getBillSuccess({
                getBill: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            getBillFailure({
                errorGetBill: e.response && e.response.data,
            }),
        );
    }
}

// custmize bill
function* billCustomize(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints?.billCustomize}/${action.payload.customerId}?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}`
                    : `${ApiEndPoints?.billCustomize}/${action.payload.customerId}?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}`,
        });
        yield put(
            billCustomizeSuccess({
                billCustomize: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            billCustomizeFailure({
                errorBillCustomize: e.response && e.response.data,
            }),
        );
    }
}

// order history
function* orderHistory(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints?.orderHistory}/${action.payload.customerId}`,
        });
        if (response && response.data) {
            yield put(
                orderHistorySuccess({
                    orderHistory: response.data,
                }),
            );
        }
    } catch (e: any) {
        yield put(
            orderHistoryFailure({
                errorOrderHistory: e.response && e.response.data,
            }),
        );
    }
}

// get user plans
function* userPlans(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints?.userPlans}/${action.payload.customerId}`
                    : `${ApiEndPoints?.userPlans}/${action.payload.customerId}`,
        });
        yield put(
            userPlansSuccess({
                userPlans: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            userPlansFailure({
                errorUserPlans: e.response && e.response.data,
            }),
        );
    }
}

// get bill forecast
function* billForecast(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints?.billForecast}/${action.payload.customerId}`
                    : `${ApiEndPoints?.billForecast}/${action.payload.customerId}`,
        });
        yield put(
            billForecastSuccess({
                billForecast: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            billForecastFailure({
                errorBillForecast: e.response && e.response.data,
            }),
        );
    }
}

// get eligible for pay later
function* eligiblePayLater(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints?.eligiblePayLater}/${action.payload.customerId}`,
        });
        yield put(
            eligiblePayLaterSuccess({
                eligiblePayLater: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            eligiblePayLaterFailure({
                errorEligiblePayLater: e.response && e.response.data,
            }),
        );
    }
}

// bill pay
function* billPay(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: domainName === domainMap.T2 ? `${ApiEndPoints?.billPay}` : `${ApiEndPoints?.billPay}`,
            body: action.payload,
        });
        yield put(
            billPaySuccess({
                billPay: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            billPayFailure({
                errorBillPay: e.response && e.response.data,
            }),
        );
    }
}

// email bill
function* emailBill(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints?.emailBill}/invoice?emailId=${action.payload.emailId}&invoiceUrl=${action.payload.invoiceUrl}&invoiceType=${action.payload.invoiceType}`,
        });
        yield put(
            emailBillSuccess({
                emailBill: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            emailBillFailure({
                errorEmailBill: e.response && e.response.data,
            }),
        );
    }
}

// email bill
function* promisePay(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'put',
            url: `/provsvc/${version}/promisetopay/${action.payload.customerId}`,
            body: action.payload.data,
        });
        yield put(
            promisePaySuccess({
                promisePay: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            promisePayFailure({
                errorPromisePay: e.response && e.response.data,
            }),
        );
    }
}

// get advance
function* getAdvance(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/billsvc/${version}/month/in/advance/amount/${action.payload.customerId}`,
        });
        yield put(
            getAdvanceSuccess({
                getAdvance: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            getAdvanceFailure({
                errorGetAdvance: e.response && e.response.data,
            }),
        );
    }
}

// data usage
function* dataUsage(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints?.dataUsage}/${action.payload.customerId}`,
        });
        yield put(
            dataUsageSuccess({
                dataUsage: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            dataUsageFailure({
                errorDataUsage: e.response && e.response.data,
            }),
        );
    }
}

// pay advance
function* payAdvance(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/billsvc/${version}/month/in/advance/pay/${action.payload.customerId}`,
        });
        yield put(
            payAdvanceSuccess({
                payAdvance: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            payAdvanceFailure({
                errorPayAdvance: e.response && e.response.data,
            }),
        );
    }
}

// get advance
function* config(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints?.config}`,
            body: action.payload,
            // url: domainName === domainMap.T2
            //     ? `/confsvc/${version}/config/keys/`
            //     : `/confsvc/${version}/config/id/PROV_CONFIG/keys/BILL_DUE_DAYS,STANDARD_BILL_DAY`,
        });
        yield put(
            configSuccess({
                config: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            configFailure({
                errorConfig: e.response && e.response.data,
            }),
        );
    }
}

// get advance
function* referalDetail(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/catalogsvc/${version}/coupon/referral/detail/${action.payload.customerId}`,
        });
        yield put(
            referalDetailSuccess({
                referalDetail: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            referalDetailFailure({
                errorReferalDetail: e.response && e.response.data,
            }),
        );
    }
}
// toggle IRILDDR services
function* toggleIRILDDR(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'put',
            url: `${ApiEndPoints.toggleIRILDDR}/${action.payload.customerId}`,
            body: action.payload,
        });
        yield put(
            toggleIRILDDRSuccess({
                toggleIRILDDR: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            toggleIRILDDRFailure({
                errorToggleIRILDDR: e.response && e.response.data,
            }),
        );
    }
}

// get status IR/ILD/DR
function* getStatusIRILDDR(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints.getStatusIRILDDR}/${action.payload.customerId}`
                    : `${ApiEndPoints.getStatusIRILDDR}/${action.payload.customerId}`,
        });
        yield put(
            getStatusIRILDDRSuccess({
                getStatusIRILDDR: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            getStatusIRILDDRFailure({
                errorGetStatusIRILDDR: e.response && e.response.data,
            }),
        );
    }
}
// get status DR
function* getUsageDR(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.getUsageDR}/${action.payload.customerId}`,
        });
        yield put(
            getUsageDRSuccess({
                getUsageDR: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            getUsageDRFailure({
                errorGetUsageDR: e.response && e.response.data,
            }),
        );
    }
}
// get status IR
function* getUsageIR(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.getUsageIR}/${action.payload.customerId}`,
        });
        yield put(
            getUsageIRSuccess({
                getUsageIR: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            getUsageIRFailure({
                errorGetUsageIR: e.response && e.response.data,
            }),
        );
    }
}

// get status ILD
function* getUsageILD(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.getUsageILD}/${action.payload.customerId}`,
        });
        yield put(
            getUsageILDSuccess({
                getUsageILD: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            getUsageILDFailure({
                errorGetUsageILD: e.response && e.response.data,
            }),
        );
    }
}

function* BillingSaga() {
    yield all([
        takeLatest(types.GET_BILL, getBill),
        takeLatest(types.BILL_CUSTOMIZE, billCustomize),
        takeLatest(types.ORDER_HISTORY, orderHistory),
        takeLatest(types.USER_PLANS, userPlans),
        takeLatest(types.BILL_FORECAST, billForecast),
        takeLatest(types.ELIGIBLE_PAY_LATER, eligiblePayLater),
        takeLatest(types.BILL_PAY, billPay),
        takeLatest(types.EMAIL_BILL, emailBill),
        takeLatest(types.PROMISE_PAY, promisePay),
        takeLatest(types.GET_ADVANCE, getAdvance),
        takeLatest(types.DATA_USAGE, dataUsage),
        takeLatest(types.PAY_ADVANCE, payAdvance),
        takeLatest(types.CONFIG, config),
        takeLatest(types.REFERAL_DETAIL, referalDetail),
        takeLatest(types.TOGGLE_IRILDDR, toggleIRILDDR),
        takeLatest(types.GET_STATUS_IRILDDR, getStatusIRILDDR),
        takeLatest(types.GET_USAGE_IR, getUsageIR),
        takeLatest(types.GET_USAGE_DR, getUsageDR),
        takeLatest(types.GET_USAGE_ILD, getUsageILD),
    ]);
}

export default BillingSaga;
